import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Grid,
  Paper,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { handleDateFormat } from "../utils/Common";

const LeadDataModal = ({ open, onClose, leadData }) => {
  if (!leadData) return null;

  const wholeLeadData = leadData?.leadsjson ? leadData.leadsjson : leadData;

  const {
    leadname,
    phone,
    email,
    ownername,
    deletedBy,
    deleted_on,
    deletedAt,
    createdon,
    source,
    mx_lead_substage,
    mx_ekyc_modified_on,
    mx_last_source_medium,
    mx_primary_source_medium,
    mx_outsourced_team,
    mx_client_code,
  } = wholeLeadData || {};

  const displayData = {
    "Lead ID": leadData?.leadsId || leadData?.leadsid || "N/A",
    "Lead Name": leadname || wholeLeadData?.leadname || "N/A",
    "Lead Mobile Number": phone || wholeLeadData?.phone || "N/A",
    "Lead Email": email || wholeLeadData?.emailaddress || "N/A",
    "Lead Owner": ownername || wholeLeadData?.owneridname || "N/A",
    "Lead Deletion Date":
      leadData?.deleted_at || wholeLeadData?.deleted_at || "N/A",
    "Lead Deleted By": leadData?.deleted_by || wholeLeadData?.deleted_by || "N/A",
    "Lead Created On": handleDateFormat(createdon) || "N/A",
    "Lead Source": source || wholeLeadData?.source || "N/A",
    "Ekyc Stage": mx_lead_substage || wholeLeadData?.mx_lead_substage || "N/A",
    "Ekyc Modified Date":
      mx_ekyc_modified_on || wholeLeadData?.mx_ekyc_modified_on || "N/A",
    "Last Source Medium":
      mx_last_source_medium || wholeLeadData?.mx_last_source_medium || "N/A",
    "Primary Source Medium":
      mx_primary_source_medium || wholeLeadData?.mx_primary_source_medium || "N/A",
    "Outsourced Team": mx_outsourced_team || wholeLeadData?.mx_outsourced_team || "N/A",
    "Client Code": mx_client_code || wholeLeadData?.mx_client_code || "N/A",
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, fontSize: "20px", fontWeight: 600 }}>
        Lead Details

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 10,
            top: 10,
            color: "#555",
            transition: "0.2s ease",
            "&:hover": {
              color: "#1976d2",
              backgroundColor: "rgba(25, 118, 210, 0.12)",
            },
          }}
        >
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "20px 25px" }}>
        <Grid container spacing={3}>
          {Object.entries(displayData).map(([key, value]) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Paper
                elevation={0}
                sx={{
                  padding: "12px 15px",
                  borderRadius: "10px",
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #eee",
                  minHeight: "85px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, color: "#333", marginBottom: "5px" }}
                >
                  {key}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: value === "N/A" ? "#777" : "#000",
                    wordBreak: "break-word",
                  }}
                >
                  {value}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LeadDataModal;